exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tree-position[data-v-ed48272e] {\n  margin: 12px 20px 0 0;\n}", ""]);

// exports
